<template>
    <div class="container-fuid bt-style">
        <div class="row">
            <div class="col-1"><img class="img-suit2" src="@/assets/images/logo2.png"></div>
            <div class="col-7 text-left">
                <p>易梵科技&nbsp;&nbsp;致力于AI+教育开发研究</p>
                <p class="p-sub">CopyRight &copy; {{cjn}}&nbsp;&nbsp;易梵科技&nbsp;&nbsp;版权所有&nbsp;&nbsp;<span style="padding-left:20px;"><a href="http://beian.miit.gov.cn/" target="_blank">浙ICP备19050141号</a></span></p>
            </div>
            <div class="col-3 text-right">
                <p><i class="fa fa-envelope fa-lg"></i>&nbsp;&nbsp;zjqm@163.com</p>
                <p class="p-sub">7×24小时不间断服务</p>
            </div>
            <div class="col-1 text-left"><img src="@/assets/images/qcode.png"></div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            cjn:(new Date()).getFullYear()

        }
    }
}
</script>
<style scoped>
  .bt-style{      
      background-color: #3a9ccf;      
      padding:20px;
      color:white;
  }
  .p-sub{
      font-size: 14px;
  }
  .img-suit2{
      width:80%;
      height:auto;
  }
</style>